if (document.querySelector('.sc-product-list')) {
  const productListSection = document.querySelector('.sc-product-list');

  const filterButtons = productListSection.querySelectorAll('.dropdown__list-option');
  const search = productListSection.querySelector('#filter_search');
  const productList = document.querySelector('.product-list__list');

  const getSelectedItems = (selector) =>
    [...document.querySelectorAll(selector)].filter((input) => input.checked).map(({ value }) => value);

  const loadMoreAxios = () => {
    const formDataInput = new FormData();
    formDataInput.append('action', 'shopCategoryLoadMore');
    formDataInput.append('primary', productListSection.dataset.categories);
    formDataInput.append('primary_locations', productListSection.dataset.locations);
    formDataInput.append('locations', getSelectedItems('.mod-filter__left input[name="location"]'));
    formDataInput.append('order', getSelectedItems('.mod-filter__left input[name="order"]'));

    formDataInput.append('categories', getSelectedItems('.mod-filter__left input[name="category"]'));

    formDataInput.append('search', search.value);
    axios
      .post(localData.apiURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        let url = '';
        ['locations', 'categories', 'search', 'order'].forEach((item) => {
          if (formDataInput.get(item)) {
            url += `${item}=${formDataInput.get(item)}&`;
          }
        });
        window.history.pushState({ urlPath: window.location.href }, null, `?${url}`);
        if (response.data.load_more_action) {
          productList.innerHTML += response.data.products;
        } else {
          productList.innerHTML = response.data.products;
        }
        productListSection.querySelector('.product-list').classList.toggle('no-product-found', !response.data.number);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  filterButtons.forEach((filter) => {
    filter.addEventListener('click', () => {
      setTimeout(() => {
        loadMoreAxios();
      }, 200);
    });
  });

  document.querySelector('.filter-search__form').addEventListener('submit', (e) => {
    e.preventDefault();
  });

  const debouncedLoadMore = debounce(() => {
    loadMoreAxios();
  }, 400);

  // Attach to event listener
  search.addEventListener('keyup', debouncedLoadMore);
}
